import C from '../../../constants';
import store from 'store';

import PolyUtil from '../../../util/PolyUtil';

export const setListing = (property) => ({
    type: C.SET_LISTING,
    payload: property
});

export const setStatus = (apply_key, status) => ({
    type: C.SET_LISTING_STATUS,
    payload: {apply_key: apply_key, status: status}
});

export const setListingAvailability = (apply_key, availability) => ({
    type: C.SET_LISTING_AVAILABILITY,
    payload: {apply_key, availability}
});

export const setListings = (listings) => ({
    type: C.SET_LISTINGS,
    payload: listings
});

export const fetchListingAvailability = (apply_key) => dispatch => {
    if (store.get('type') === 'tenant') {
        return PolyUtil.fetchWrapper('/api/tenant/listings/' + apply_key + '/check-availability/', {
            method: 'GET'
        }).then((data) => {
            return dispatch(setListingAvailability(apply_key, data));
        }).catch((error) => {
            console.log("Error:", error);
        });
    }
};

export const fetchStatus = (apply_key) => dispatch => {
    if (store.get('type') === 'tenant') {
        return PolyUtil.fetchWrapper('/api/tenant/listings/' + apply_key + '/application/status/', {
            method: 'GET'
        }).then((data) => {
            return dispatch(setStatus(apply_key, data));
        }).then(() => {
            return dispatch(fetchListingAvailability(apply_key));
        }).catch((error) => {
            console.log(error);
        });
    }
};

export const fetchListing = (apply_key) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/listings/' + apply_key + '/', {
        method: 'GET'
    }).then((data) => {
        return dispatch(setListing(data));
    }).then(() => {
        return dispatch(fetchStatus(apply_key));
    }).catch((error) => {
        console.log(error);
    });
};

export const fetchListings = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/listings/', {
        method: 'GET'
    }).then((data) => {
        return dispatch(setListings(data));
    }).catch((error) => {
        console.log(error);
    });
};



// WEBPACK FOOTER //
// ./src/containers/listings/actions/listings.js